// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

// import course css modules
import courseStyles from '../courseModuleStyles.css';
import moment from 'moment';

const AdminCourseListItem = ({ course, match, sponsor, study }) => {
  return (
    <tr>
      <td className="_40">
        <Link
          to={study._id ? `/admin/content-management/studies/${study._id}/courses/${course._id}` : `/admin/content-management/courses/${course._id}`}
        >
          {course.title}
        </Link>
      </td>
      <td className="_20">{sponsor.name}</td>
      <td className="_20">{study.name}</td>
      <td className="_20">{moment(course.updated).format("MMMM Do YYYY, h:mm a")}</td>
    </tr>
  )
}

AdminCourseListItem.propTypes = {
  course: PropTypes.object.isRequired
  , sponsor: PropTypes.object
  , study: PropTypes.object
}

AdminCourseListItem.defaultProps = {
  sponsor: {}
  , study: {}
}

export default withRouter(AdminCourseListItem);



// WEBPACK FOOTER //
// modules/course/components/AdminCourseListItem.js.jsx